import { z } from 'zod'

import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const ConfigClientModuleStatus = z.enum([
  'ACTIVATED',
  'DISABLED',
  'SITUATIONAL'
])
export const ConfigClientModule = z.object({
  id: z.string(),
  patient: PersonaInfoSummary,
  status: ConfigClientModuleStatus,
  observation: z.string().nullish()
})

export type ConfigClientModuleStatus = z.infer<typeof ConfigClientModuleStatus>
export type ConfigClientModule = z.infer<typeof ConfigClientModule>
